import { Component, Input } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { AdvisorWidgetData } from '../advisor-widget/domain/model/advisor-widget.model';

@Component({
    selector: 'ifbp-advisor-widget-button',
    templateUrl: './advisor-widget-button.component.html',
    styleUrls: ['./advisor-widget-button.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({
                maxHeight: '0',
                opacity: '0',
                overflow: 'hidden',
                visibility: 'hidden'
            })),
            state('expanded', style({
                maxHeight: '1000px',
                opacity: '1',
                visibility: 'visible'
            }))
        ])
    ],
    standalone: false
})
export class AdvisorWidgetButtonComponent {
  @Input() data: AdvisorWidgetData;
  isExpanded = false;

  toggleWidget(): void {
    this.isExpanded = !this.isExpanded;
  }
}
